<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;大会主席团
        </div>
        <img src="../../assets/images/bjtitle2.png" class="img" />
        <img :src="imgurl" class="mainimg" alt="" />
        <img src="../../assets/images/bjfooter.png" class="footerimg" />
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
export default {
    name: 'bjzhuanjia',
    data() {
        return {
            imgurl: '',
        }
    },
    mixins: [mixin],
    created() {
        this.initbjShare();
        this.getinfo()
        document.title = "第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会";
    },
    methods: {
        getinfo() {
            let that = this;
            this.$axios.post('/api/api/web/activity/GetBJConfig?code=TYZJ').then(res => {
                if (res.RetCode == "10000") {
                    // console.log(res.Data.Url)
                    that.imgurl = res.Data.Url
                }
            });
        },
        back() {
            this.$router.replace({ name: 'BJZL' })
        }
    }
}
</script>

<style lang="scss" scoped>
body {
    -webkit-overflow-scrolling: unset
}

.container {
    height: 100%;
    width: 100%;
    position: relative;
    -webkit-overflow-scrolling: unset // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}

.footerimg {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background-image: linear-gradient(to right, #01B671, #2D5EAA);
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.mainimg {
    width: 100%;
    position: relative;
    z-index: 100;
    margin-bottom: 1.8rem;
}
</style>